import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import {Box, Flex, Text} from '@radix-ui/themes';

const CustomLineChart = ({ data, lines, xAxisKey, yAxisDomain }) => {
  console.log('CustomLineChart data', yAxisDomain);
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={data}
        width="100%"
        margin={{ top: 20, right: 30, left: 5, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={xAxisKey} />
        <YAxis domain={yAxisDomain} />
        <Tooltip />
        <Legend />
        {lines.map((line, index) => (
          <Line
          connectNulls
          {...line}
            key={index}
            type="monotone"
            // dataKey={line.dataKey}
            // stroke={line.stroke}
            // name={line.name}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default CustomLineChart;